import { Controller} from "stimulus"

export default class extends Controller {
  static targets = ["field", "latitude", "longitude"]

  connect() {
    window.feather.replace()
    if (typeof (google) != "undefined"){
      this.initializeAutocomplete()
    }

    // send message to other controllers
    window.dispatchEvent(new CustomEvent("configureSelectedItems"))
  }

  initializeAutocomplete() {
    this.autocomplete()
  }

  autocomplete() {
    if (this._autocomplete == undefined) {
      this._autocomplete = new google.maps.places.Autocomplete(this.fieldTarget)
      this._autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])
      this._autocomplete.addListener('place_changed', this.locationChanged.bind(this))
      this.enableEnterKeySearch(this.fieldTarget)
    }
    return this._autocomplete
  }

  enableEnterKeySearch(input) {
    /* Store original event listener */
    const _addEventListener = input.addEventListener

    const addEventListenerWrapper = (type, listener) => {
      if (type === 'keydown') {
        /* Store existing listener function */
        const _listener = listener
        listener = (event) => {
          /* Simulate a 'down arrow' keypress if no address has been selected */
          const suggestionSelected = document.getElementsByClassName('pac-item-selected').length
          if (event.key === 'Enter' && !suggestionSelected) {
            const e = new KeyboardEvent('keydown', {
              key: 'ArrowDown',
              code: 'ArrowDown',
              keyCode: 40,
            })
            _listener.apply(input, [e])
          }
          _listener.apply(input, [event])
        }
      }
      _addEventListener.apply(input, [type, listener])
    }

    input.addEventListener = addEventListenerWrapper
  }

  autocompleteSubmit(e) {
    e.preventDefault()

    const arrowDownKey = new KeyboardEvent('keydown', {
      key: 'ArrowDown',
      code: 'ArrowDown',
      keyCode: 40
    })
    const enterKey = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13
    })

    this.fieldTarget.focus()
    this.fieldTarget.dispatchEvent(arrowDownKey)
    this.fieldTarget.dispatchEvent(enterKey)
  }

  locationChanged() {
    let place = this.autocomplete().getPlace()

    if (!place.geometry) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      window.alert("No details available for input: '" + place.name + "'");
      return;
    }

    this.latitudeTarget.value = place.geometry.location.lat()
    this.longitudeTarget.value = place.geometry.location.lng()
    this.element.requestSubmit()
  }

  preventSubmit(e) {
    if (e.key == "Enter") { e.preventDefault() }
  }
}
